module.exports = __webpack_public_path__ + "static/img/5.e02c856.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/5.png
// module id = 8Iin
// module chunks = 0